import { TODAY_LIST } from "@/mocks/gua";

const TAG_COLOR: Record<string, string> = {
  娱乐: "bg-orange-50 text-orange-700",
  综艺: "bg-rose-50 text-rose-600",
  影视: "bg-amber-50 text-amber-700",
  科技: "bg-emerald-50 text-emerald-700",
  电竞: "bg-teal-50 text-teal-700",
  财经: "bg-stone-100 text-stone-700",
  社会: "bg-stone-100 text-stone-700",
};

export default function TodayList() {
  return (
    <section id="today" className="w-full border-b border-stone-200/60 bg-white">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-orange-600">今日滚动 · 上疏下密</p>
            <h2 className="mt-1.5 flex items-center gap-2 text-2xl font-extrabold text-stone-900 md:text-3xl">
              今日新瓜速递
              <span className="rounded-full bg-orange-600 px-2 py-0.5 text-xs font-bold text-white">LIVE</span>
            </h2>
            <p className="mt-2 text-sm text-stone-500">按时间倒序滚动更新，标题 + 短摘要，快速扫一眼不掉队。</p>
          </div>
          <a href="#top" className="whitespace-nowrap text-sm font-medium text-orange-600 hover:text-orange-700">
            更多新瓜 <i className="ri-arrow-right-line align-[-1px]" />
          </a>
        </div>

        <div className="mt-6 grid gap-3 md:gap-4 lg:grid-cols-2">
          {TODAY_LIST.map((item) => (
            <a
              key={item.title}
              href="#scene"
              className="group flex items-start gap-4 rounded-lg border border-stone-200/70 bg-[#fdfbf6] p-4 transition hover:border-orange-200 hover:bg-orange-50/40 md:p-5"
            >
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-600/90 text-xs font-bold text-white">
                {item.time}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`rounded-md px-2 py-0.5 text-[11px] font-semibold ${TAG_COLOR[item.tag] ?? "bg-stone-100 text-stone-700"}`}>
                    {item.tag}
                  </span>
                  <h3 className="whitespace-nowrap text-sm font-bold text-stone-800 transition group-hover:text-orange-700 md:text-base">
                    {item.title}
                  </h3>
                </div>
                <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-stone-500 md:text-[13px]">
                  {item.summary}
                </p>
              </div>
              <i className="ri-arrow-right-up-line mt-1 hidden shrink-0 text-stone-300 transition group-hover:text-orange-500 lg:block" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}